import { useApolloClient } from '@apollo/client'
import React, { useState } from 'react'

import Modal from '@@components/modal'

import { REMOVE_VISIT_MUTATION } from './_queries'

export default function DeleteVisitModal({ visit, onDone, noConfirm }) {
  const [waiting, setWaiting] = useState(noConfirm)
  const client = useApolloClient()

  const onConfirm = async () => {
    setWaiting(true)

    await client.mutate({
      mutation: REMOVE_VISIT_MUTATION,
      variables: {
        input: {
          id: visit.id,
        },
      },
    })

    onDone(true)
  }

  if (noConfirm) {
    setTimeout(onConfirm)
  }

  if (waiting) {
    return (
      <Modal>
        <div className="align-self-center card shadow">
          <div className="card-body">
            <div className="spinner-border" />
          </div>
        </div>
      </Modal>
    )
  }

  return (
    <Modal onClose={() => onDone(false)}>
      <div className="align-self-center card shadow">
        <div className="card-body">
          <p className="my-2 fs-5">Are you sure you want to delete this visit?</p>
        </div>
        <div className="card-footer d-flex">
          <button id="delete_visit_confirm" onClick={onConfirm} type="button" className="btn btn-danger me-1">
            Yes
          </button>
          <button type="button" onClick={() => onDone(false)} className="btn btn-outline-secondary ms-1">
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  )
}
